<div class="w-full relative">
  <div class="relative">
    <input type="text" [id]="displayId" [name]="displayName" [value]="currentInputValue || displayValue"
      [placeholder]="!displayLabel ? displayPlaceholder : ''" [required]="isRequired" [disabled]="isDisabled"
      [readonly]="isReadonly" (click)="toggleDropdown()" (blur)="onBlur($event)" (focus)="onFocus($event)" 
      (input)="onInputChange($event)" (keydown)="onKeyDown($event)"
      [class.border-red-500]="hasError"
      [class.border-primary]="!hasError"
      class="w-full px-3 py-2.5 text-[14px] border rounded-md text-primary bg-bg focus:outline-none transition-colors disabled:bg-surface disabled:cursor-not-allowed disabled:opacity-60 font-semibold h-[40px]" 
      [class.cursor-pointer]="isReadonly" />

    <label *ngIf="displayLabel" [for]="displayId" [class.floating-label-active]="isFocused || hasValue || showDropdown"
      class="floating-label absolute left-3 text-[13px] font-medium text-muted pointer-events-none transition-all duration-200">
      {{ displayLabel }}
      <span *ngIf="isRequired" class="text-status-danger ml-1">*</span>
    </label>

    <div (click)="toggleDropdown()"
      class="absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-auto cursor-pointer z-10">
      <svg class="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="hasError && errorMessage" class="mt-1 text-red-500 text-[11px] font-medium">
    {{ errorMessage }}
  </div>

  <!-- Time Picker Dropdown -->
  <div *ngIf="showDropdown"
    class="fixed w-[240px] min-w-[200px] border border-border rounded-xl bg-bg overflow-hidden shadow-md z-[999999] calendar-popup"
    [style.top.px]="dropdownTop"
    [style.right.px]="dropdownRight">

    <div class="p-3">
      <!-- Scrollable Lists (selection is highlighted directly in the lists) -->
      <div class="grid grid-cols-3 gap-2 h-40">
        <!-- Hours List -->
        <div class="overflow-y-auto custom-scrollbar">
          <div *ngFor="let h of hours" (click)="selectHour(h, $event)"
            class="text-center py-1.5 text-xs font-medium cursor-pointer rounded transition-colors"
            [class.bg-primary]="h === selectedHour"
            [class.text-white]="h === selectedHour"
            [class.font-bold]="h === selectedHour"
            [class.hover:bg-primary/10]="true">
            {{ h }}
          </div>
        </div>

        <!-- Minutes List -->
        <div class="overflow-y-auto custom-scrollbar">
          <div *ngFor="let m of minutes" (click)="selectMinute(m, $event)"
            class="text-center py-1.5 text-xs font-medium cursor-pointer rounded transition-colors"
            [class.bg-primary]="m === selectedMinute"
            [class.text-white]="m === selectedMinute"
            [class.font-bold]="m === selectedMinute"
            [class.hover:bg-primary/10]="true">
            {{ m }}
          </div>
        </div>

        <!-- Periods List -->
        <div class="overflow-y-auto custom-scrollbar">
          <div *ngFor="let p of periods" (click)="selectPeriod(p, $event)"
            class="text-center py-1.5 text-xs font-medium cursor-pointer rounded transition-colors"
            [class.bg-primary]="p === selectedPeriod"
            [class.text-white]="p === selectedPeriod"
            [class.font-bold]="p === selectedPeriod"
            [class.hover:bg-primary/10]="true">
            {{ p }}
          </div>
        </div>
      </div>
    </div>
    <!-- Footer with Done button to commit selection -->
    <div class="border-t border-border p-2 bg-surface/30 flex justify-end gap-2">
      <button type="button" (click)="confirmSelection()" class="px-3 py-1.5 bg-primary text-white rounded text-sm">Done</button>
    </div>
  </div>
</div>